module.exports = __webpack_public_path__ + "img/genexW.14ddb354.png";